import React from 'react';

import type { CardFooterProps } from './Card.types';

export const CardFooter = React.forwardRef<HTMLDivElement, CardFooterProps>(
  ({ as: Component = 'div', theme, testId, ...restProps }, ref) => {
    return (
      <Component
        ref={ref}
        className='hg-card__footer'
        data-theme={theme}
        data-testid={testId}
        {...restProps}
      />
    );
  }
);

CardFooter.displayName = 'Card.Footer';
